import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {CommonService} from '@app/components/_common/common.service';
import {environment} from '@environments/environment';
import {fuseAnimations} from '@fuse/animations';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {AppState} from '@store/app.states';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Observable} from 'rxjs';
import {ClearAll} from '../surveys-list/store/surveys-list.actions';
import {UxInteractions} from '../surveys-list/store/surveys-list.reducers';
import {currentUxInteraction} from './store/surveys-list.selector';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {SurveysListService} from '../../../@shared/_referencesLists/surveys-list/surveys-list.service';
import {FuseSidebarService} from '../../../@fuse/components/sidebar/sidebar.service';
import {AppUserContextService, contextViewTypeRef} from '../../../@shared/_referencesLists/reference-lists/app-user-context.service';

declare var $: any;

@Component({
  selector: 'app-surveys-list-admin',
  templateUrl: './surveys-list-component-admin.component.html',
  styleUrls: ['./surveys-list-component-admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SurveysListAdminComponent extends OnDestroyMixin implements OnInit, OnDestroy {

  display: contextViewTypeRef = 'grid';

  uxInteractions$: Observable<UxInteractions> = this.store.select(currentUxInteraction).pipe(untilComponentDestroyed(this));

  baseUrl = environment.legacyBaseUrl;

  secretToken = '';

  constructor(
    private store: Store<AppState>,
    public translate: TranslateService,
    public router: Router,
    private commonService: CommonService,
    public dialog: MatDialog,
    public surveysListService: SurveysListService,
    private _fuseSidebarService: FuseSidebarService,
    private appUserContextService: AppUserContextService,
  ) {
    super();
    this._fuseSidebarService.getSidebar('navbar')?.fold();

  }

  ngOnInit() {
    // this.store.dispatch(new RefreshList());

    // this.store.select(getUrlsInfo)
    //   .pipe(untilComponentDestroyed(this))
    //   .subscribe(data => {
    //     this.secretToken = data.secretToken;
    //   });

    this.surveysListService.store$
      .pipe(untilComponentDestroyed(this))
      .subscribe((datas) => {
        this.secretToken = datas.secretToken;
      });

  }

  changeDisplay() {
    this.display = this.display === 'grid' ? 'list' : 'grid';
    this.appUserContextService.updateDisplay('surveys', this.display);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.store.dispatch(new ClearAll());
  }

  refresh(): void {
    // this.store.dispatch(new RefreshList());
    this.surveysListService.refreshList();
  }

  // displaySurveyPreview(surveyId: number) {
  //   this.commonService.displaySurveyPreview(surveyId);
  // }

  // annotate(surveyId: number) {
  //   this.router.navigate(['/annotation', surveyId]);
  // }

  // displayDetailedResponses(surveyId) {
  //   this.commonService.displayDetailedResponses(surveyId);
  // }

  // getPreviewUrl() {
  //   return this.commonService.getPreviewUrl(1074);
  // }

  // // openPreviewDialog(surveyId) {
  // //   this.commonService.displaySurveyPreview(surveyId);
  // }

  // calculateNbValid(rowData) {
  //   return rowData.nb_response_valid;
  // }


}
